<template>
  <div id="footer">
    © J. Paul Getty Trust. |
    <a href="https://www.getty.edu/legal/privacy.html">Privacy Policy</a> |
    <a href="https://www.getty.edu/legal/copyright.html">Terms of Use</a> |
    <a href="https://www.getty.edu/legal/trademarks/index.html">Trademarks</a> |
    All images © Ed Ruscha. Used with permission.
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="scss" scoped>
#footer {
  width: 100%;
  background-color: black;
  color: white;
  text-align: center;
  font-size: 12px;
  padding: 4px;
  height: 20px;

  @media (max-width: 1000px) {
    font-size: 10px;
  }

  @media (max-width: 815px) {
    font-size: 8px;
    padding: 0px;
  }

  a,
  a:visited {
    color: white;
  }
}
</style>
